import React from 'react';
import { MessageSquare } from 'lucide-react';
import { useBoardComments } from './BoardCommentsContext';
import './BoardComments.css';

interface BoardCommentPinProps {
  nodeId: string;
  count: number;
  expanded: boolean;
  onClick: () => void;
}

const BoardCommentPin: React.FC<BoardCommentPinProps> = ({ count, expanded, onClick }) => {
  if (count <= 0 && !expanded) return null;

  return (
    <button
      type="button"
      className={`board-comment-pin nodrag${expanded ? ' is-expanded' : ''}`}
      title={`${count} comment${count === 1 ? '' : 's'}`}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <MessageSquare size={14} />
      {count > 0 && <span className="board-comment-pin-count">{count}</span>}
    </button>
  );
};

export default BoardCommentPin;
